import ESelectCidade2 from './ESelectCidade2'

export default ESelectCidade2
